// Petit état indépendant : le client HTTP peut le lire sans importer session/cache.
let consultation = false;
export function definirLectureSeule(valeur: boolean): void {
  consultation = valeur;
}
export function lectureSeuleActive(): boolean {
  return consultation;
}
